import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';

import { useThemeMode } from '../../contexts/ThemeContext';
import {
  buildTrendPalette,
  DEFAULT_TREND_SCHEME,
  normalizeTrendScheme,
  TREND_SCHEMES,
} from '../../themes/trendPalette';
import { formatSigned } from '../../utils/trend';

/**
 * 등락 색 방식 선택 (한국식 / 글로벌식)
 * 각 옵션 옆에 현재 테마 배경 기준으로 보정된 색의 미리보기("+1.23% / −1.23%")를 보여준다.
 */
const TrendColorSchemeSelector = () => {
  const theme = useTheme();
  const { personalPreferences, setTrendColorScheme } = useThemeMode() || {};
  const current = normalizeTrendScheme(personalPreferences?.trendColorScheme || DEFAULT_TREND_SCHEME);

  const handleChange = (event) => {
    if (typeof setTrendColorScheme === 'function') {
      setTrendColorScheme(event.target.value);
    }
  };

  return (
    <FormControl component="fieldset" sx={{ width: '100%' }}>
      <FormLabel component="legend" sx={{ fontWeight: 600, color: 'text.primary', mb: 1 }}>
        등락 색상
      </FormLabel>
      <RadioGroup
        name="trend-color-scheme"
        value={current}
        onChange={handleChange}
        aria-label="등락 색상 방식"
      >
        {Object.entries(TREND_SCHEMES).map(([key, scheme]) => {
          const palette = buildTrendPalette({
            scheme: key,
            mode: theme.palette.mode,
            paper: theme.palette.background.paper,
            background: theme.palette.background.default,
            textSecondary: theme.palette.text.secondary,
          });
          return (
            <FormControlLabel
              key={key}
              value={key}
              control={<Radio />}
              sx={{ alignItems: 'center', mr: 0 }}
              label={(
                <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', columnGap: 1.5 }}>
                  <Typography variant="body2" sx={{ fontWeight: 600 }}>
                    {scheme.label}
                  </Typography>
                  <Typography variant="body2" color="text.secondary">
                    {scheme.description}
                  </Typography>
                  <Typography
                    component="span"
                    variant="body2"
                    data-testid={`trend-preview-${key}`}
                    sx={{ fontWeight: 600, fontVariantNumeric: 'tabular-nums' }}
                  >
                    <Box component="span" sx={{ color: palette.gain.main }}>{formatSigned(1.23, { suffix: '%' })}</Box>
                    {' / '}
                    <Box component="span" sx={{ color: palette.loss.main }}>{formatSigned(-1.23, { suffix: '%' })}</Box>
                  </Typography>
                </Box>
              )}
            />
          );
        })}
      </RadioGroup>
      <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
        수익/손실, 등락률 표시에 쓰이는 색입니다. 색뿐 아니라 +/− 부호와 화살표로도 구분됩니다.
      </Typography>
    </FormControl>
  );
};

export default TrendColorSchemeSelector;
